// extracted by mini-css-extract-plugin
export default {"header":"menu-topo_header__FUAYn","headerNome":"menu-topo_headerNome__0gk9D","headerBotoes":"menu-topo_headerBotoes__jTC8q"};